export default function GedcomX() {
  const consts = {
    MALE: 'http://gedcomx.org/Male',
    FEMALE: 'http://gedcomx.org/Female',
    BIRTH: 'http://gedcomx.org/Birth',
    CHRISTENING: 'http://gedcomx.org/Christening',
    DEATH: 'http://gedcomx.org/Death',
    BURIAL: 'http://gedcomx.org/Burial',
    RESIDENCE: 'http://gedcomx.org/Residence',
  }

  return consts
}

export const isMale = (genderType) => {
  const gcx = GedcomX()
  return genderType === gcx.MALE
}

export const isFemale = (genderType) => {
  const gcx = GedcomX()
  return genderType === gcx.FEMALE
}

export const determineGender = (genderType) => {
  if (isMale(genderType)) {
    return 'male'
  }
  if (isFemale(genderType)) {
    return 'female'
  }

  return 'unknown'
}
